export default __webpack_public_path__ + "static/jeans-44ece3aa41a50cf8b223e5b6a57a0e7c.png";